import { useSettingsStore } from '@/store/api/settingsStore';

const ALLOWED_SLOT_DURATIONS = [15, 30, 45, 60, 90];

/**
 * Hook pour récupérer les paramètres de planning configurés
 * @returns { slotDuration, startTime, endTime }
 */
export const useScheduleSettings = () => {
  const { settings } = useSettingsStore();
  const slotDuration = settings.schedule?.slotDuration || 45;
  const startTime = settings.schedule?.startTime || "08:00";
  const endTime = settings.schedule?.endTime || "21:00";
  
  // Validation de sécurité pour slotDuration
  if (!ALLOWED_SLOT_DURATIONS.includes(slotDuration)) {
    console.warn(`Invalid slotDuration: ${slotDuration}, falling back to 45`);
    return { slotDuration: 45, startTime, endTime };
  }
  
  return { slotDuration, startTime, endTime };
};

/**
 * Hook pour récupérer la durée des slots configurée (rétrocompatibilité)
 * @returns slotDuration en minutes (fallback à 45 si non défini ou invalide)
 */
export const useSlotDuration = (): number => {
  const { slotDuration } = useScheduleSettings();
  return slotDuration;
};
